<template >
  <div class="container-display" id='container-display'>
    <div class="secondary-panel" id="secondary-panel">
      <h2>风机基础计算</h2>
      <!-- 1.剖面显示 ---------------------------------------------------------------------------------------------------->
      <div class="cadZone">
        <div class="svg1" @wheel="zoomHandler($event)">
        </div>
      </div>
      <!-- 2.项目名称 ---------------------------------------------------------------------------------------------------->

      <!-- 3.风机参数 ---------------------------------------------------------------------------------------------------->
      <div class="container_params">
        <form style="display: inline-block;" class="params_form" novalidate> <!-- inline-block消除了表单元素之间的间隙 -->
          <fieldset>
            <!-- 3.1.参数标题---------------------------------------------------------------->
            <legend> 风机基础参数输入</legend>

            <!-- 3.2.参数选项卡------------------------------------------------------------->
            <div class="tab tab_for_mobile">
              <button v-for="item in tab" :key="item.index" :class="item.isShow ? 'btn_active' : ''"
                @click="tabshow(item.index)" type="button">
                {{ item.name }}
                <i class="iconfont icon-sanjiao-zhankai" v-show="item.isShow"></i>
              </button>
              <input type="button" value="基础计算" @click="designCompletely()" class="doAxios" id="fullCalculation" />
            </div>

            <!-- 3.3.0.  basic参数------------------------------------------------------------>
            <div class="radius">
              <div class="params_geometry params_basic" v-show="tab[0].isShow">
                <!-- 项目名称 -->
                <form>
                  <fieldset>
                    <legend>基本信息</legend>
                    <label for="project_name_d" style="width: 70px;">
                      <h2 style="width: 70px;">项目名称</h2>
                    </label>
                    <input type="text" placeholder="请输入项目名称" v-model="project_name.value" style="margin-right: 30px;"
                      id="project_name_d" class="basic" />
                    <label for="importance">
                      <h2>结构重要性系数</h2>
                    </label>
                    <input type="number" placeholder="1.1" v-model="params_calculation[0].value" id="importance"
                      @keydown="filterNum($event)" @change="checkNum($event)" class="basic" />
                  </fieldset>
                </form>
                <!-- 分项系数参数form -->
                <form>
                  <fieldset>
                    <legend>荷载分项系数</legend>
                    <table class="params">
                      <tbody>
                        <tr class='params_tr params_calculation'>
                          <div class='params_tr_div calculation' v-for="param in params_calculation[1]" :key="param.name">
                            <td>
                              <label :class="param.name" :for="param.name">
                                <h2>{{ param.title }}</h2>
                              </label>
                            </td>
                            <td>
                              <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="number"只能输入整数-->
                              <input type="number" v-model.number="param.value" :name="param.name" :id="param.name"
                                @keydown="filterNum($event)" @change="checkNum($event)" />
                            </td>
                          </div>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </form>
                <!-- 混凝土强度等级、保护层厚度form -->
                <form>
                  <fieldset>
                    <legend>混凝土强度等级、保护层厚度(mm)</legend>
                    <table class="params">
                      <tbody>
                        <tr class='params_tr cover_and_concrete_container'>
                          <template v-for="(item, index) in [concrete, cover]" :key="index">
                            <div class='params_tr_div cover_and_concrete' v-for="param in item" :key="param.name">
                              <td>
                                <label :class="param.name" :for="param.name">
                                  <h2>
                                    <span v-if="index === 0">强度等级:</span>
                                    <span v-else>保护层厚度:</span>
                                    {{
                                      param.title.substr(param.title.length - 2, 2)
                                    }}
                                  </h2>
                                </label>
                              </td>
                              <td>
                                <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="number"只能输入整数-->
                                <input type="number" v-model="param.value" :name="param.name" :id="param.name"
                                  :readOnly="param.status ? 'readonly' : false" @keydown="filterNum($event)"
                                  @change="checkNum($event)" @mouseover="param.imgShow = true"
                                  @mouseleave="param.imgShow = false" />
                                <div v-if="index === 1" class="params_table">
                                  <img src="/imgs/cover.png" v-show="param.imgShow" />
                                </div>
                              </td>
                            </div>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </form>
                <!-- 地下水位、覆土及基底土参数form -->
                <form>
                  <fieldset>
                    <legend>地下水位、覆土、基底土及变形参数</legend>
                    <table class="params">
                      <tbody>
                        <tr class='params_tr cover_and_concrete_container'>
                          <div class='params_tr_div cover_and_concrete' v-for="param in params_soil_extra"
                            :key="param.name" :id="param.name">
                            <td>
                              <label :class="param.name" :for="param.name + 'd'">
                                <h2>
                                  {{
                                    param.title
                                  }}</h2>
                              </label>
                            </td>
                            <td>
                              <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="number"只能输入整数-->
                              <input type="number" v-model.number="param.value" :name="param.name" :id="param.name + 'd'"
                                @keydown="filterNum($event)" @change="checkNum($event, param.name == 'water_depth_high')"
                                @mouseover="param.imgShow = true" @mouseleave="param.imgShow = false" />
                              <div v-if="param.name === 'allowed_deform' || param.name === 'allowed_incline'"
                                class="params_table deformation_table">
                                <img src="/imgs/deformation.png" v-show="param.imgShow" />
                              </div>
                            </td>
                          </div>
                        </tr>
                      </tbody>
                    </table>
                  </fieldset>
                </form>
              </div>

              <!-- 3.3.1.geometry参数------------------------------------------------------->
              <div class="params_geometry" v-show="tab[1].isShow">
                <table class="params">
                  <tbody>
                    <tr class='params_tr'>
                      <div class='params_tr_div' v-for="param in params_geometry" :key="param.name">
                        <td>
                          <label :class="param.name" :for="param.name + 'd'">
                            <h2>{{
                              param.title
                            }}</h2>
                          </label>
                        </td>
                        <td>
                          <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="text"-->
                          <input type="number" v-model.number="param.value" :id="param.name + 'd'"
                            :name="param.name + 'd'" :disabled="param.disabled"
                            :readOnly="param.disabled ? 'readonly' : false" @keydown="filterNum($event)"
                            @change="checkNum($event)" />
                        </td>
                      </div>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <br />
                <div class="tip" style="padding-left: 22px; ">
                  注：1、尺寸参数的单位均为mm。 2、以下外围厚度、坡比和长高比为自动计算，不需输入。
                </div>
                <table class="params">
                  <tbody>
                    <tr class='params_tr'>
                      <div class='params_tr_div' v-for="param in geometry_result" :key="param.name">
                        <td>
                          <label :class="param.name">
                            <h2>{{
                              param.title
                            }}</h2>
                          </label>
                        </td>
                        <td>
                          <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="text"-->
                          <input type="text" v-model.number="param.value" disabled readOnly />
                        </td>
                      </div>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 3.3.2.       force参数------------------------------------------------------->
              <div class="params_bar params_force " v-show="tab[2].isShow">
                <div class="tab">
                  <button @click="show_thirdPanel('third_panel_seism', true)" type="button">
                    地震作用输入
                  </button>
                  <button @click="show_thirdPanel('third_panel_fatigue', true)" type="button">
                    疲劳荷载输入
                  </button>
                </div>
                <!-- 分隔线div -->
                <div class="parting_line"></div>
                <div class="force_container">
                  <table class="params">
                    <tbody>
                      <tr>
                        <th>工况/荷载作用</th>
                        <th>Fr(kN)</th>
                        <th> Mr(kN.m)</th>
                        <th> Fz(kN)</th>
                        <th> Mz(kN.m)</th>
                      </tr>
                      <tr v-for="(param, index) in params_force" :key="index">
                        <template v-for="(item, key) in param" :key="key">
                          <td v-if="key == 'name'" style="padding: 10,0;">
                            <label :class="param.name" :for="param.fr.name">{{
                              param.name
                            }}</label>
                          </td>
                          <td v-else style="position: relative;">
                            <input type="number" v-model.number="item.value" :id="item.name"
                              :readOnly="item.status ? 'readonly' : false" :disabled="item.status"
                              @keydown="filterNum($event, true)" @change="checkNum($event)" :name="item.name" />
                            <!-- 提示div
                          <div v-if="item.status && item.name.includes('eq')" v-show="item.isActive" class="input_tip">
                            请在"地震作用输入"中输入
                          </div>
                          <div v-if="item.status && !item.name.includes('eq')" v-show="item.isActive" class="input_tip">
                            请在"疲劳荷载输入"中输入
                          </div> -->
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tip" style="padding: 5px 0 0 35px;">
                    注:（1）输入的是地震作用，而非地震工况。地震工况会自动叠加正常运行工况计算；
                    （2）地震作用在“地震作用输入”页面输入，疲劳荷载在“疲劳荷载输入”页面输入。
                  </div>
                </div>
              </div>

              <!-- 3.3.3.       soil参数---------------------------------------------------------->
              <div class="params_bar params_soil" v-show="tab[3].isShow">
                <div class="soil_container">
                  <table class="params">
                    <tbody>
                      <tr>
                        <th>土层名称</th>
                        <th>厚度(m)</th>
                        <th> 重度<br>(kN/m3)</th>
                        <th> 压缩模量(MPa)</th>
                        <th> 动态压缩模量(MPa)</th>
                        <th> 孔隙比</th>
                        <th> 泊松比</th>
                        <th> 剪切波速<br>(m/s)</th>
                        <th> 承载力特征值(kPa)</th>
                        <th> 宽度修<br>正系数</th>
                        <th> 深度修<br>正系数</th>
                        <th> 抗震调<br>整系数</th>
                      </tr>
                      <tr v-for="(param, index) in params_soil" :key="index" class="soil_tr"
                        @keyup="insert_delete_soil($event, index)">
                        <td style="width: 140px; padding-left: 1px;">
                          <input type="text" v-model="param.name.value" :class="param.name.name" :name="'name_' + index"
                            :id="'name_' + index" />
                        </td>
                        <template v-for="(item, key) in param" :key="key">
                          <td v-if="key !== 'index' & key !== 'name'" style="width: 50px;">
                            <input type="number" v-model="item.value" class="soil_input" @keydown="filterNum($event)"
                              @change="checkNum($event)" :name="item.name + '_' + index" :id="item.name + '_' + index" />
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tip">
                    <div class="tip_for_pc">
                      注：点击某行任一输入框后，按Insert键向后插入土层，按Delete键删除当前土层。
                    </div>
                    <div class="tip_for_mobile">
                      注：点 + 号在最后面插入新的土层，点 - 号删除最后一层土层。
                      <input type="button" value=" + " class="add_soil_btn" @click="add_soil()" />
                      <input type="button" value=" - " class="delete_soil_btn" @click="delete_soil()" />
                    </div>
                    <!-- <div class="modulus_container_wraper"> -->
                    <div class="modulus_container" @mouseover="modulusShow = true" @mouseleave="modulusShow = false">
                      压缩模量参考范围
                      <div class="modulus_table">
                        <img src="/imgs/modulus.png" v-show="modulusShow" />
                      </div>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>

              <!-- 3.3.4.       bolt参数---------------------------------------------------------->
              <div class="params_bolt" v-show="tab[4].isShow">
                <table class="params">
                  <tbody>
                    <tr class='params_tr'>
                      <div class='params_tr_div' v-for="param in params_bolt" :key="param.name">
                        <td>
                          <label :id="param.name" :for="param.name + '_d'">
                            <h2>
                              {{
                                param.title
                              }}</h2>
                          </label>
                        </td>
                        <td>
                          <input type="number" v-model.number="param.value" :id="param.name + '_d'"
                            :name="param.name + '_d'" :readOnly="param.status ? 'readonly' : false"
                            :disabled="param.status" @keydown="filterNum($event)" @change="checkNum($event)" />
                        </td>
                      </div>
                    </tr>
                  </tbody>
                </table>
                <div class="tip">注：尺寸参数的单位均为mm。</div>
              </div>

              <!-- 3.3.5.       design_bar参数---------------------------------------------------------->
              <div class="params_bolt" v-show="tab[5].isShow">
                <table class="params">
                  <tbody>
                    <tr class='params_tr'>
                      <div class='params_tr_div' v-for="param in  design_bar " :key="param.name">
                        <td>
                          <label :id="param.name" :for="param.name + '_d'">
                            <h2>
                              {{
                                param.title
                              }}</h2>
                          </label>
                        </td>
                        <td>
                          <input type="number" v-model.number="param.value" :id="param.name + '_d'"
                            v-if="param.type == 'value'" :name="param.name + '_d'"
                            :readOnly="param.status ? 'readonly' : false" :disabled="param.status"
                            @keydown="filterNum($event)" @change="checkNum($event)" @input="checkSection()" />
                          <select :id="param.No" @change="setValue($event, param.No)" v-if="param.type == 'strength'"
                            class="select">
                            <option value=270>HRB300</option>
                            <option value=360 selected>HRB400</option>
                            <option value=435>HRB500</option>
                          </select>
                          <div v-if="param.type == 'diameter'" class="select">
                            <select :id="param.No" @change="setValue($event, param.No)" class="select_list">
                              <option value=20>20</option>
                              <option value=22>22</option>
                              <option value=25 selected>25</option>
                              <option value=28>28</option>
                              <option value=32>32</option>
                              <option value=36>36</option>
                              <option value=40>40</option>
                            </select>
                          </div>
                          <div v-if="param.type == 'num'" class="select">
                            <select :id="param.No" @change="setValue($event, param.No), checkSection()"
                              class="select_list">
                              <option value=1>1</option>
                              <option value=2>2</option>
                              <option value=3 selected>3</option>
                            </select>
                          </div>
                        </td>
                      </div>
                    </tr>
                  </tbody>
                </table>
                <div class="tip">注：1、直径的单位均为mm。2、钢筋仅需输入钢筋直径，软件根据计算结果自动配筋。</div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>

      <!-- 4. secondary_panel下的第三级div:  地震作用输入 -->
      <div class="third_panel" id="third_panel_seism">
        <div class="third_input">
          <form style="display: inline-block;" class="params_form">
            <fieldset>
              <legend>地震作用输入（任选一种方式输入）</legend>
              <!-- 4.0.地震放大系数↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->

              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>地震放大系数（对所有方式有效）</legend>
                  <div class="wraper_for_mobile">
                    <div class=" params_amplification">
                      <table class="params">
                        <tbody>
                          <tr class='params_tr'>
                            <div class='params_tr_div' v-for=" param  in  seism_amplification " :key="param.name">
                              <td>
                                <label :class="param.name" :for="param.name">
                                  <h2>
                                    {{
                                      param.title
                                    }}</h2>
                                </label>
                              </td>
                              <td>
                                <!-- type="number"只能输入数字，小数点都不能输入 所以用input type="number"只能输入整数 -->
                                <input type="number" v-model.number="param.value" :name="param.name" :id="param.name"
                                  @keydown="filterNum($event)" @change="checkNum($event)" />
                              </td>
                            </div>
                          </tr>
                        </tbody>
                      </table>
                      <div class="tip">注：以上放大系数分别按《建筑与市政工程抗震通用规范 GB55002-2021》4.1.1条之1、2款取值。</div>
                    </div>
                  </div>
                </fieldset>
              </form>

              <!-- 4.0.地震放大系数↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->

              <!-- 4.1.方式一↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>方式一：按加速度反应谱计算并按规范要求修正（推荐）</legend>
                  <div class="wraper_for_mobile">
                    <div class="params_bolt params_seism">
                      <table class="params">
                        <tbody>
                          <tr class='params_tr'>
                            <div class='params_tr_div' v-for=" param  in  params_seism " :key="param.name">
                              <td>
                                <label :class="param.name" :for="param.name">
                                  <h2>
                                    {{
                                      param.title
                                    }}</h2>
                                </label>
                              </td>
                              <td>
                                <select :id="param.name" @change="seism_IndensitySet($event)"
                                  v-if="param.name == 'seism_indensity'">
                                  <option value=0 selected>6度(0.05g)</option>
                                  <option value=1>7度(0.10g)</option>
                                  <option value=2>7度(0.15g)</option>
                                  <option value=3>8度(0.20g)</option>
                                  <option value=4>8度(0.30g)</option>
                                  <option value=5>9度(0.40g)</option>
                                </select>
                                <input type="number" v-model.number="param.value" :name="param.name" :id="param.name"
                                  @keydown="filterNum($event)" @change="checkNum($event)" v-else />
                              </td>
                            </div>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="tab">
                    <button class="btn_comfirm" type="button"
                      @click="seismCalculation_method1(params_seism, params_force, amplifcation)">计算地震作用</button>
                  </div>
                </fieldset>
              </form>
              <!-- 4.1.方式一↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->

              <!-- 4.2.方式二↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>方式二：直接使用厂家地震作用（不推荐）</legend>
                  <div class="wraper_for_mobile">
                    <div class="params_seism_1  params_force ">
                      <div class="force_container">
                        <table class="params">
                          <tbody>
                            <tr>
                              <th>工况/荷载</th>
                              <th>Fr(kN)</th>
                              <th> Mr(kN.m)</th>
                              <th> Fz(kN)</th>
                              <th> Mz(kN.m)</th>
                            </tr>
                            <tr v-for=" param  in  params_temp_force " :key="param.name">
                              <template v-for="( item, key ) in  param " :key="key">
                                <td v-if="key == 'name'" style="padding: 10,0;">
                                  <label :class="param.name" :for="param.fr.name + '_temp'">{{
                                    param.name
                                  }}</label>
                                </td>
                                <td v-else style="position: relative;" class="temp_force">
                                  <input type="number" v-model.number="item.value" :id="item.name + '_temp'"
                                    :name="item.name + '_temp'" :readOnly="item.status ? 'readonly' : false"
                                    :disabled="item.status" @keydown="filterNum($event, true)"
                                    @change="checkNum($event)" />
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="tab">
                    <button class="btn_comfirm" type="button"
                      @click="seismCalculation_method2(params_temp_force, params_force, amplifcation)">计算地震作用</button>
                  </div>
                </fieldset>
              </form>
              <!-- 4.2.方式二↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->


              <!-- 4.3.计算结果↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>地震作用计算结果(可手动修改):</legend>
                  <div class="wraper_for_mobile">
                    <div class="params_seism_1  params_force seism_result">
                      <div class="force_container">
                        <table class="params">
                          <tbody>
                            <tr>
                              <th>工况/荷载</th>
                              <th>Fr(kN)</th>
                              <th> Mr(kN.m)</th>
                              <th> Fz(kN)</th>
                              <th> Mz(kN.m)</th>
                            </tr>
                            <tr v-for="( param, index ) in  [params_force.small_eq, params_force.large_eq] " :key="index">
                              <template v-for="( item, key ) in  param " :key="key">
                                <td v-if="key == 'name'" style="padding: 10,0;">
                                  <label :class="param.name" :for="param.fr.name + 'result'">{{
                                    param.name
                                  }}</label>
                                </td>
                                <td v-else style="position: relative;" class="temp_force">
                                  <input type="number" v-model.number="item.value" :id="item.name + 'result'"
                                    :name="item.name + 'result'" @keydown="filterNum($event, true)"
                                    @change="checkNum($event)" />
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
              <!-- 4.3.计算结果↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->
              <div class="tab comfirm_tab">
                <button class="btn_comfirm" type="button"
                  @click="show_thirdPanel('third_panel_seism', false)">确认关闭</button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      <!-- 5. secondary_panel下的第三级div:  疲劳输入 -->
      <div class="third_panel" id="third_panel_fatigue">
        <div class="third_input">
          <form style="display: inline-block;" class="params_form">
            <fieldset>
              <legend>疲劳荷载输入</legend>
              <!-- 5.1.疲劳荷载输入↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>均值、幅值输入</legend>
                  <div class="wraper_for_mobile">
                    <div class="params_fatigue  params_force ">
                      <div class="force_container">
                        <table class="params">
                          <tbody style="table-layout: none;">
                            <tr>
                              <th>均值/幅值</th>
                              <th>Fx(kN)</th>
                              <th>Fy(kN)</th>
                              <th>Fz(kN)</th>
                              <th>Mx(kN.m)</th>
                              <th>My(kN.m)</th>
                              <th>Mz(kN.m)</th>
                            </tr>
                            <tr v-for=" param  in  params_temp_fatigue " :key="param.name">
                              <template v-for="( item, key ) in  param " :key="key">
                                <td v-if="key == 'name'" style="padding: 10,0;" class="fatigue_label">
                                  <label :class="param.name" :for="param.fx.name">{{
                                    param.name
                                  }}</label>
                                </td>
                                <td v-else style="position: relative;" class="temp_force">
                                  <input type="number" v-model.number="item.value" :id="item.name" :name="item.name"
                                    :readOnly="item.status ? 'readonly' : false" :disabled="item.status"
                                    @keydown="filterNum($event, true)" @change="checkNum($event)" />
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="tab">
                    <button class="btn_comfirm" type="button"
                      @click="fatigueCalculation(params_temp_fatigue, params_force.fatigue_upper, params_force.fatigue_lower)">计算疲劳荷载工况</button>
                  </div>
                </fieldset>
              </form>
              <!-- 5.1.疲劳荷载输入↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->

              <!-- 5.2.计算结果↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
              <form style="display: inline-block;" class="params_form">
                <fieldset>
                  <legend>疲劳荷载计算结果：</legend>
                  <div class="wraper_for_mobile">
                    <div class="params_force fatigue_result">
                      <div class="force_container">
                        <table class="params">
                          <tbody>
                            <tr>
                              <th>荷载工况</th>
                              <th>Fr(kN)</th>
                              <th> Mr(kN.m)</th>
                              <th> Fz(kN)</th>
                              <th> Mz(kN.m)</th>
                            </tr>
                            <tr v-for="( param, index ) in  [params_force.fatigue_upper, params_force.fatigue_lower] "
                              :key="index">
                              <template v-for="( item, key ) in  param " :key="key">
                                <td v-if="key == 'name'" style="padding: 10,0;">
                                  <label :class="param.name" :for="param.fr.name + 'result'">{{
                                    param.name
                                  }}</label>
                                </td>
                                <td v-else style="position: relative;" class="temp_force">
                                  <input type="number" v-model.number="item.value" :id="item.name + 'result'"
                                    :name="item.name + 'result'" :readOnly="item.status ? 'readonly' : false"
                                    :disabled="item.status" @keydown="filterNum($event)" @change="checkNum($event)" />
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
              <!-- 5.2计算结果↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->
              <div class="tab comfirm_tab">
                <button class="btn_comfirm" type="button"
                  @click="show_thirdPanel('third_panel_fatigue', false)">确认关闭</button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <!-- 6. secondary_panel下的第三级div:  疲劳输入 -->
      <div class="container_params">
        <form style="display: inline-block;" class="params_form" novalidate> <!-- inline-block消除了表单元素之间的间隙 -->
          <fieldset>
            <!-- 6.1.参数标题---------------------------------------------------------------->
            <legend> 初步计算结果</legend>
            <div class="result_container">
              <div class="volum result">
                <div class="volum_container">
                  <table class="params">
                    <tbody>
                      <tr class="soil_tr">
                        <td>
                          <span>基础混凝土方量(立方米)：</span>
                        </td>
                        <td>
                          <span>{{ total_material.C40 }}</span>
                        </td>
                      </tr>
                      <tr class="soil_tr">
                        <td>
                          <span>基础垫层方量(立方米)：</span>
                        </td>
                        <td>
                          <span>{{ total_material.C15 }}</span>
                        </td>
                      </tr>
                      <tr class="soil_tr">
                        <td>
                          <span>基坑开挖方量(立方米)：</span>
                        </td>
                        <td>
                          <span>{{ total_material.dig }}</span>
                        </td>
                      </tr>
                      <tr class="soil_tr">
                        <td>
                          <span>基坑回填方量(立方米)：</span>
                        </td>
                        <td>
                          <span>{{ total_material.fillback }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="reaction result">
                <div class="reaction_container">
                  <table class="params">
                    <tbody>
                      <tr>
                        <td>工况</td>
                        <td>偏心率e/R</td>
                        <td> 面积脱开比</td>
                        <td> 允许脱开比</td>
                        <td> Pkmax(kPa)</td>
                        <td> Pk(kPa)</td>
                      </tr>
                      <tr v-for="( item, index ) in  reaction_result " :key="index" class="soil_tr">
                        <td>
                          <span>{{ item[0] }}</span>
                        </td>
                        <template v-for="( subItem, key ) in  item[1] " :key="key">
                          <td>
                            <span>{{ subItem }}</span>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <!-- 7. docx预览 采用"third_panel second_panel" 的样式 -->
    <div class="third_panel second_panel" id="docx" v-show="show_docx">
      <!-- 下载选项卡----------------------------------------------------------- -->
      <div class="tab file_tab">

        <button @click="show_docx = false" type="button">关闭预览</button>
        <button @click="downloadFile()" type="button">下载计算书</button>

      </div>
      <!-- <div class="docx"></div> -->
      <!-- <iframe id="docx_iframe" :src="docx_src"></iframe> -->
      <div class="docx_wraper">
        <vue-office-docx :src="docx_src"></vue-office-docx>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Power_WindBase_Design",
};
</script>

<script setup>

import { barWatcher } from "../assets/JS/Power_WB_barWatcher.js";
import { reactive, onMounted, watch, computed, ref } from "vue";
// 0-1引入绘图文件
import { SVG } from "@svgdotjs/svg.js";
// 0-2引入数据文件 （须在2.4和3中，以及画图文件js中同时添加引入的参数）
import { useWindBaseDataStore } from "@/store/windBaseData";
// import { useTempStore } from '@/store/temp';
import { useUserStore } from '@/store/user';
import Toast from "@/utils/toast";
import { Processing } from "@/utils/processing";
import { getForce, getSoil, getDict } from "@/utils/datawash";
import { layout } from "../assets/JS/Power_WB_LayoutForDesign.js";
// 0-3引入监听窗口大小变化
import elementResizeDetectorMaker from "element-resize-detector";
// import { submit } from "@/utils/submit";
//0-4 基础计算函数
import { seismCalculation_method1, seismCalculation_method2, fatigueCalculation } from "@/assets/JS/wb_design_spread/LoadProcessing";
import { _designCompletely, _designQuickly } from "@/api/index";
import { filterNum, checkNum } from "@/utils/number_input.js";
// 方法一：用docx-preview渲染
// import { renderAsync } from "docx-preview";
// const docx = require("docx-preview");
// window.JSZip = require("jszip");

// 方法二：用vue-office渲染
import '@vue-office/docx/lib/index.css'
import VueOfficeDocx from '@vue-office/docx'
import { API } from "@/api/url";
//浏览器类型判断
import { useWebTypeStore } from '@/store/webtype';
const webTypeStore = useWebTypeStore();
// webTypeStore.setWebType();

let docx_src = ref('')     // 预览文件地址
let fileType = ''            // 文件类型

let modulusShow = ref(false); // 模量显示

let [
  temp_params_geometry,  //geometry需要进行过滤处理
  temp_params_bolt,  //bolt需要进行过滤处理
  params_bar,
  cover,
  concrete,
  params_force,
  params_soil,
  params_soil_extra,
  total_material,
  params_calculation,
  design_bar
] = useWindBaseDataStore().getData([
  "params_geometry",
  "params_bolt",
  "params_bar",
  "cover",
  "concrete",
  "params_force",
  "params_soil",
  "params_soil_extra",
  "total_material",
  "params_calculation",
  "design_bar"
]);

let params_geometry = temp_params_geometry.filter(
  (item) => item.name !== "T_set" && item.name !== "TL" && item.name !== "TW" &&
    item.name !== "TH" && item.name !== "Tdist" && item.name !== "P_set" &&
    item.name !== "PW" && item.name !== "Pdist" && item.name !== "angle1" &&
    item.name !== "angle2" && item.name !== "bar_h" && item.name !== "bar_v" &&
    item.name !== "DD" && item.name !== "R_observe"
);

let params_bolt = temp_params_bolt.filter(
  item => item.name !== "BBrace_num" && item.name !== "BBrace_width" &&
    item.name !== "BBrace_length" && item.name !== "BBrace_t" && item.name !== "BBrace_bar"
)
let backfill = params_geometry.find(item => item.name === "backFillRatio");
let project_name = useWindBaseDataStore().project_name;
const userStore = useUserStore();
// 1.定义参数
// 1.1.定义基础参数
let tab = reactive([
  { index: 0, name: "基本参数", isShow: true },
  { index: 1, name: "几何参数", isShow: false },
  { index: 2, name: "荷载参数", isShow: false },
  { index: 3, name: "土层参数", isShow: false },
  { index: 4, name: "锚栓参数", isShow: false },
  { index: 5, name: "配筋参数", isShow: false },
]);
// 1.2.定义地震作用输入参数
let seism_amplification = reactive({
  terrain_amplification: {
    name: "terrain_amplification",
    title: "地形放大系数(1~1.6)",
    value: 1,
  },
  near_field_amplification: {
    name: "near_field_amplification",
    title: "近场效应系数(1~1.5)",
    value: 1,
  },
});
const amplifcation = computed(
  () => seism_amplification.terrain_amplification.value * seism_amplification.near_field_amplification.value
);
// 1.3.定义用于计算地震作用的临时荷载参数
let params_temp_force = reactive({
  small_eq_temp: {
    name: "多遇地震作用",
    fr: { name: "s_eq_fr", value: 0, status: false, isActived: false },
    mr: { name: "s_eq_mr", value: 0, status: false, isActived: false },
    fz: { name: "s_eq_fz", value: 0, status: false, isActived: false },
    mz: { name: "s_eq_mz", value: 0, status: false, isActived: false },
  },
  large_eq_temp: {
    name: "罕遇地震作用",
    fr: { name: "l_eq_fr", value: 0, status: false, isActived: false },
    mr: { name: "l_eq_mr", value: 0, status: false, isActived: false },
    fz: { name: "l_eq_fz", value: 0, status: false, isActived: false },
    mz: { name: "l_eq_mz", value: 0, status: false, isActived: false },
  },
});
// 1.4.定义用于计算地震作用的地震参数
let params_seism = reactive({
  seism_indensity: {
    name: "seism_indensity",
    title: "抗震设防烈度",
    value: 0,
  },
  seism_period: {
    name: "seism_period",
    title: "特征周期(s)",
    value: 0.35,
  },
  hub_height: {
    name: "hub_heigth",
    title: "轮毂中心高度(m)",
    value: 120,
  },
  hub_weight: {
    name: "hub_weight",
    title: "风轮+机舱质量(t)",
    value: 278,
  },
  tower_weight: {
    name: "tower_weight",
    title: "塔架质量(t)",
    value: 298,
  },
  the_first_frequency: {
    name: "the_first_frequency",
    title: "塔架第一自振频率",
    value: 0.171,
  },
})
// 1.5 定义疲劳荷载参数
let params_temp_fatigue = reactive({
  even_load: {
    name: "疲劳荷载平均值",
    fx: { name: "even_load_fx", value: 0 },
    fy: { name: "even_load_fy", value: 0 },
    fz: { name: "even_load_fz", value: 0 },
    mx: { name: "even_load_mx", value: 0 },
    my: { name: "even_load_my", value: 0 },
    mz: { name: "even_load_mz", value: 0 },
  },
  amplitude: {
    name: "疲劳荷载振幅",
    fx: { name: "amplitude_fx", value: 0 },
    fy: { name: "amplitude_fy", value: 0 },
    fz: { name: "amplitude_fz", value: 0 },
    mx: { name: "amplitude_mx", value: 0 },
    my: { name: "amplitude_my", value: 0 },
    mz: { name: "amplitude_mz", value: 0 },
  },
});
// 1.6 定义初步验算result的临时参数
let r = params_geometry.find(item => item.name === "R");
let r2 = params_geometry.find(item => item.name === "R2");
let h1 = params_geometry.find(item => item.name === "H1");
let h2 = params_geometry.find(item => item.name === "H2");
let br_out = temp_params_bolt.find(item => item.name === "Br_out");

let geometry_result = reactive(
  [
    {
      name: "bolt_cover",
      title: "锚栓外围厚度(m)",
      value: computed(() => Math.round((r2.value - br_out.value / 1000) * 1000) / 1000),
    },
    {
      name: "base_slop",
      title: "圆台坡比 1：",
      value: computed(() => h2.value != 0 ? Math.round((r.value - r2.value) / h2.value * 1000) / 1000 : 9999)
    },
    {
      name: "ratio_l/h",
      title: "底板悬挑长高比",
      value: computed(() => (h2.value + h1.value) != 0 ? Math.round((r.value - r2.value) / (h1.value + h2.value) * 1000) / 1000 : 9999)
    },
  ]
);


let reaction_result = reactive(
  [
    ['正常运行工况：', ['', '', '', '', '']],
    ['极端荷载工况：', ['', '', '', '', '']],
    ['多遇地震工况(+X/-Z)：', ['', '', '', '', '']],
    ['多遇地震工况(+X/+Z)：', ['', '', '', '', '']],
  ]
);



let svg1 = SVG();
let layout_obj = null;


// 2.初始化
onMounted(() => {
  let secondary_panel = document.querySelector("#secondary-panel");
  secondary_panel.style.minWidth = Math.max((window.innerWidth - 200) / 2, 1000) + "px";
  secondary_panel.style.width = (window.innerWidth - 200) / 2 + "px";


  let cadZone = reactive(document.querySelector(".cadZone"));
  // 2.1设置svg画布大小
  let svgSizeRatio = 4;
  let svgWidth = 43000;
  svg1.addTo(".svg1").viewbox(0, 0, svgWidth, svgWidth / svgSizeRatio);
  svg1.size(cadZone.clientWidth, cadZone.clientWidth / svgSizeRatio);
  cadZone.style.height = "auto";
  cadZone.style.height = cadZone.clientWidth / svgSizeRatio + "px";


  // 2.2监听窗口大小变化
  let erd = elementResizeDetectorMaker();
  erd.listenTo(cadZone, function () {
    svg1.size(cadZone.clientWidth, cadZone.clientWidth / svgSizeRatio);
    cadZone.style.height = "auto";
    cadZone.style.height = cadZone.clientWidth / svgSizeRatio + "px";
  });

  // 2.3绘制第一张图
  layout_obj = layout(svg1, params_geometry, params_bolt);

  let label_1 = document.querySelector("#Grout_strength");
  label_1.style.padding = "0px";
  // let cover_other_label = document.querySelector(".cover_other");
  // cover_other_label.style.width = "40px";
  // let label_2 = document.querySelector(".holeCushionThick");
  // label_2.style.padding = "0px";
});

// 3.监听参数变化
// 3.0 监听函数
barWatcher(params_geometry, params_bar, params_bolt, cover);
// 3.1~~~~~~~~~~~~~~~~~~~~~~~~~params_geometry~~~~~~~~~~~~~~~~~~~~~~~~~~~~
watch(params_geometry, (newVal, oldVal) => {
  layout_obj = layout_obj.replace(
    layout(svg1, newVal, params_bolt)
  );
});

// 3.2~~~~~~~~~~~~~~~~~~~~~~~~~params_bolt~~~~~~~~~~~~~~~~~~~~~~~~~~~~
watch(params_bolt, (newVal, oldVal) => {
  layout_obj = layout_obj.replace(
    layout(svg1, params_geometry, newVal)
  );
});

// 3.3~~~~~~~~~~~~~~~~~~~~~~~~~快速计算结果~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
watch(params_geometry,
  (newVal, oldVal) => {
    designQuickly()
  }
)
watch(params_force,
  (newVal, oldVal) => {
    designQuickly()
  }
)
watch(params_soil_extra,
  (newVal, oldVal) => {
    designQuickly()
  }
)


// 4定义事件处理函数
// ~~~~~~~~~~~~tabshow~~~~~~~~~~
function tabshow(index) {
  tab.forEach((item) => {
    if (item.index === index) {
      item.isShow = true;
    } else {
      item.isShow = false;
    }
  });
}



// 防止输入负数、字符和不正确的小数点~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// const tempStore = useTempStore();

// const filterNum = (e, minus = false) => {
//   let prohibit = minus ? ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'] : ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
//   if (e.keyCode == 46 || e.keyCode == 8) {
//     return
//   } else if (!prohibit.includes(e.key)) {
//     e.preventDefault();
//   }
//   tempStore.value = e.target.value;
// };


// const checkNum = (e) => {

//   let obj = document.getElementById(e.target.id)
//   let scale = 3

//   const t = String(obj.value).charAt(0)


//   // obj.value = obj.value.replace(/[^\u4E00-\u9FA5]/g, ""); //清除"数字"和"."以外的字符  keydown已经过滤了
//   obj.value = obj.value.replace(/[^\d.]/g, "");  //j禁止输入中文
//   obj.value = obj.value.replace(/^\./g, ""); //验证第一个字符是数字而不是其他字符
//   obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 不能输入连续的.
//   obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");//清除后面的.
//   var re = new RegExp("^(\\-)*(\\d+)\\.(\\d{" + scale + "}).*$");
//   obj.value = obj.value.replace(re, '$1$2.$3'); //只能输入scale个小数
//   if (obj.value === 0) {
//     obj.value = tempStore.value;
//   }
//   if (t === '-') {
//     obj.value = '-' + obj.value;
//   }

//   let event = document.createEvent('Event')
//   event.initEvent('input', true, true)
//   event.eventType = 'message'
//   obj.dispatchEvent(event)
// };
// 防止输入负数、字符和不正确的小数点~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// 以鼠标为中心放大缩小
function zoomHandler(event) {
  let element = document.querySelector(".svg1");
  event.preventDefault();
  let zoom = 1;
  if (event.deltaY > 0) {
    zoom = 0.9;
  } else {
    zoom = 1.1;
  }
  let transform = element.style.transform;
  let match = transform.match(/scale\(([\d.]+)\)/);
  if (match) {
    let scale = parseFloat(match[1]);
    scale *= zoom;
    element.style.transform = transform.replace(match[1], scale);
  } else {
    element.style.transform = "scale(" + zoom + ")";
  }
}

// 显示提示信息
// function showTips(item) {
//   item.isActive = true;
// }
// function hideTips(item) {
//   item.isActive = false;
// }

// force 参数的地震、疲劳输入模块的显示与隐藏
function show_thirdPanel(id, isShow) {
  let element = document.getElementById(id);
  if (isShow) {
    element.style.display = "block";
  } else {
    element.style.display = "none";
  }
}

// soil参数的插入与删除
function insert_delete_soil(e, index) {
  console.log(e);
  if (e.key == "Delete") {
    if (params_soil.length > 1) {
      params_soil.splice(index, 1);
    } else {
      return;
    }
  }
  if (e.key == "Insert") {
    let new_soil = {};
    for (let key in params_soil[index]) {
      // new_soil[key] = Object.assign({}, params_soil[index][key]);
      new_soil[key] = {}
      Object.assign(new_soil[key], params_soil[index][key]);
    }
    new_soil.name.value = "soil_" + String(params_soil.length) + Math.floor(Math.random() * 10);
    params_soil.splice(index + 1, 0, new_soil);
  }
}
// function add_soil(index) {
//   if (index-1<0 || index-1>=params_soil.length) {
//     Toast('请选择合理的土层数！', 'secondary-panel');
//     return;
//   } else {
//     params_soil.splice(index-1, 0, params_soil[index-1])
//   }
// }
// function delete_soil(index) {
//   if (index-1<0 || index-1>=params_soil.length) {
//     Toast('请选择合理的土层数！', 'secondary-panel');
//     return;
//   } else {
//     params_soil.splice(index-1, 1);
//   }
// }
function add_soil() {
  let index = params_soil.length - 1;
  params_soil.splice(index, 0, params_soil[index]);
}
function delete_soil() {
  let index = params_soil.length - 1;
  params_soil.splice(index, 1);
}


// 地震烈度设置
function seism_IndensitySet(e) {
  let select = e.target;
  let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
  let value = select.options[i].value;
  params_seism.seism_indensity.value = value;
}


// selected改变SET的值
function setValue(e, No) {
  let select = e.target;
  let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
  let value = select.options[i].value;
  let bar_obj = design_bar.find((obj) => obj.No === String(No));
  bar_obj.value = value;
}
// 验证分段数是否合理
function checkSection() {
  let r2 = params_geometry.find(item => item.name === "R2").value;
  let r = params_geometry.find(item => item.name === "R").value;
  let t_r2 = design_bar.find(item => item.name === "tangential_r2");
  let t_r3 = design_bar.find(item => item.name === "tangential_r3");
  let num = design_bar.find(item => item.name === "tangential_num").value;
  if (num == 3) {
    if (t_r2.value <= r2 || t_r2.value >= r || t_r3.value <= r2 || t_r3.value >= r || t_r2.value >= t_r3.value) {
      t_r2.value = Math.round((r2 + (r - r2) / 3) * 100) / 100;
      t_r3.value = Math.round((r2 + (r - r2) * 2 / 3) * 100) / 100;
    }
  }
  if (num == 2) {
    if (t_r2.value <= r2 || t_r2.value >= r) {
      t_r2.value = Math.round((r2 + (r - r2) / 2) * 100) / 100;
    }
  }

}





// 风机基础(完整)设计计算

let show_docx = ref(false)


let gama_for_submit = {
  'g': [params_calculation[1].g1.value, params_calculation[1].g2.value],
  'q': params_calculation[1].q.value,
  'ev': params_calculation[1].ev.value,
  'eh': params_calculation[1].eh.value,
}

function designCompletely() {
  if (project_name.value === '') {
    Toast('请填写项目名称！', 'secondary-panel');
    return;
  } else {
    let dataSubmit = reactive(document.querySelector("#fullCalculation"));
    let value = dataSubmit.value;
    // dataSubmit.value = "基础计算中...";
    let processing = Processing("基础计算中", "fullCalculation");
    _designCompletely({
      'nickname': userStore.nickname,
      'project_name': project_name.value,
      'importance': params_calculation[0].value,
      'gama': gama_for_submit,
      'concrete': getDict(concrete),
      'cover': { 'a0_bottom': cover[0].value, 'a0_other': cover[1].value },
      'water_depth': params_soil_extra.water_depth.value,
      'backfill_density': params_soil_extra.backfill_density.value,
      // 'dynamic_es': params_soil_extra.backfill_modulus.value,
      'rotational_stiffness': params_soil_extra.rotational_stiffness.value,
      'horizontal_stiffness': params_soil_extra.horizontal_stiffness.value,
      'friction_coeff': params_soil_extra.friction_coeff.value,
      'allowed_deform': params_soil_extra.allowed_deform.value,
      'allowed_incline': params_soil_extra.allowed_incline.value,
      'geometry': getDict(params_geometry),
      'backfill': { 'backfill_ratio': backfill.value, 'backfill_slopY': backfill.slopY },
      'force': getForce(params_force),
      'soil': getSoil(params_soil),
      'bolt': getDict(params_bolt),
      'bar': getDict(design_bar),

      'total_material': total_material,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast('基础计算完成！', 'secondary-panel', 50, 1000, true);
          clearInterval(processing);
          dataSubmit.value = value;
          // 返回的结果下载
          show_docx.value = true;
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          fileType = res.headers['content-disposition'].split(';')[1].split('=')[1];

          // 使用preview模式打开  不用
          // const options = {
          //   className: 'docx', // 默认和文档样式类的类名/前缀
          //   inWrapper: true, //  启用围绕文档内容渲染包装器
          //   ignoreWidth: false, //  禁止页面渲染宽度
          //   ignoreHeight: false, //  禁止页面渲染高度
          //   ignoreFonts: false, //  禁止字体渲染
          //   breakPages: true, //  在分页符上启用分页
          //   ignoreLastRenderedPageBreak: true, //  禁用lastRenderedPageBreak元素的分页
          //   experimental: false, //  启用实验性功能（制表符停止计算）
          //   trimXmlDeclaration: true, //   如果为真，xml声明将在解析之前从xml文档中删除
          //   debug: false, //  启用额外的日志记录
          //   useBase64URL: true, // 如果为true，图片、字体等将被转换为base 64 URL，否则使用URL.createObjectURL
          //   useMathMLPolyfill: false, //  包括用于 chrome、edge 等的 MathML polyfill。
          //   showChanges: false // 启用文档更改（插入/删除）的实验性呈现
          // };
          // let containerElement = document.getElementById("docx");
          // renderAsync(blob, containerElement, options)

          //  使用VUE打开
          docx_src.value = window.URL.createObjectURL(blob);
        }
        else {
          Toast('参数输入有误！', 'secondary-panel', 50, 1000, true);
          clearInterval(processing);
          dataSubmit.value = value;
        }
      })
      .catch((err) => {
        console.log(err);
        Toast('计算出错啦！', 'secondary-panel', 50, 1000, true);
        clearInterval(processing);
        dataSubmit.value = value;
      });
  }

}
// 2、 发起下载请求
function downloadFile() {

  if (webTypeStore.isWX && webTypeStore.isMobile) {
    const URL = API + '/windbase/download/designs/?nickname=' + userStore.nickname + '&project_name=' + project_name.value;
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = URL;
    link.download = project_name.value + '.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } else {

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = docx_src.value;  // downloadURL 对象: 在完整计算中赋值给docx_src了
    link.download = decodeURI(fileType);    // 文件类型名称: 在完整计算中赋值给docx_src了
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(docx_src.value);  // 必须释放URL 对象
  }
}
// 风机基础(快速)设计计算

function designQuickly() {
  _designQuickly({
    'water_depth': params_soil_extra.water_depth.value,
    'backfill_density': params_soil_extra.backfill_density.value,
    // 'dynamic_es': params_soil_extra.backfill_modulus.value,
    'geometry': getDict(params_geometry),
    'backfill': { 'backfill_ratio': backfill.value, 'backfill_slopY': backfill.slopY },
    'force': getForce(params_force),
  })
    .then((res) => {
      if (res.status === 200) {
        let result = res.data.data;

        for (let i = 0; i < result.mean.length; i++) {
          reaction_result[i][1][0] = !isNaN(parseFloat(result.uneven[i][0])) ? result.uneven[i][0].toFixed(3) : result.uneven[i][0];
          reaction_result[i][1][1] = (result.uneven[i][1] * 100).toFixed(2) + '%';
          reaction_result[i][1][2] = i === 0 ? '0%' : '25%';
          reaction_result[i][1][3] = result.uneven[i][2].toFixed(2);
          reaction_result[i][1][4] = isNaN(result.uneven[i][0]) ? 0 : (!isNaN(parseFloat(result.mean[i])) ? result.mean[i].toFixed(2) : result.mean[i]);
        }
      }
      else {
        Toast('参数输入有误！', 'secondary-panel');
      }
    })
    .catch((err) => {
      console.log(err);
      Toast('计算出错啦！', 'secondary-panel');
    });




}
</script>


<style scoped>
/* 1. 参数区属性 *******************************/
.secondary-panel * {
  box-sizing: border-box;

}

.container-display {
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;
  min-width: 1100px;
  height: calc(100% - 60px);
  /* min-height: var(--min-secondary-panel-height); */
  background-color: var(--displayZone-color);
  overflow: hidden;
}

.secondary-panel {
  position: relative;
  margin: 0;
  width: 1100px;
  min-width: 1100px;
  /* padding: 0, 5px; */
  /* border-left: 2px solid var(--button-color);
  border-right: 2px solid var(--button-color); */
  /* overflow: hidden; */
  height: 100%;
  overflow: auto;
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
@media (orientation: portrait) and (max-width: 768px) {
  .container-display {
    width: 100%;
    min-width: 100%;
  }

  .secondary-panel {
    width: 100% !important;
    min-width: 100% !important;
  }

  .third_panel {
    width: 100% !important;
    min-width: 100% !important;
    margin: 0 !important;
  }

  #docx {
    width: 115% !important;
    min-width: 115% !important;
  }
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
/* 1-1*/
.cadZone {
  width: 100%;
  height: 250px;
  background-color: black;
  overflow: hidden;
}

.svg1 {
  width: 101%;
}

/* 1-2 */
.container_params {
  width: 100%;
  /* height: 420px; */
}


.tip {
  font-size: 13px;
  padding: 3px 3px 0 10px;
  margin-top: 4px;
}

th {
  padding: 10px 0;
}

/* tab~~~~~~~~~~~~~~~~~~~~ */
.tab {
  padding-left: 19px;
  position: relative;
}

/* 计算按钮的样式 */
.container-display .tab .doAxios {
  width: 110px;
  height: 30px;
  padding: 0 !important;
  margin: 0;
  position: absolute;
  right: 19px;
}

.tab button i {
  position: absolute;
  top: 101%;
  right: 50%;
  transform: translateX(50%);
  color: var(--button-active-color);
}

.tab button {
  height: 30px;
  padding: 4px 10px 6px 10px;
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
@media (orientation: portrait) and (max-width: 768px) {
  .tab_for_mobile button {
    width: 50px;
    height: 50px;
  }


  .container-display .tab .doAxios {
    right: 10px;
    height: 50px;
  }

}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */






/* 各参数的大div 的样式************************/
.radius {
  overflow-y: hidden;
  margin: 10px 8px;
  border-radius: 8px;
  border: 1px solid #000;
  box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.5);
}

.container-display .secondary-panel .params_geometry,
.params_force,
.params_soil,
.params_bolt {
  height: 345px;
  margin: 0 !important;
  overflow: auto;
  /* background-color: #f3f3f3; */
  background-color: var(--params-container-color);
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
@media (orientation: portrait) and (max-width: 768px) {

  .container-display .secondary-panel .tab {
    width: 100% !important;
    min-width: 100% !important;
    padding-left: 5px;
  }


  .container-display .secondary-panel .params_geometry,
  .params_force,
  .params_soil,
  .params_bolt,
  .params_basic {
    width: 960px !important;
    min-width: 960px !important;
    padding-left: 5px;
  }

  .radius::-webkit-scrollbar {
    display: none;
  }




  fieldset {
    width: 100% !important;
    min-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .params_form {
    width: 100% !important;
    min-width: 100% !important;
  }
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */



.container-display .secondary-panel .params_geometry {
  padding-left: 10px;
}


.container-display .secondary-panel .params_bolt {
  padding-left: 5px;
}


/* 各参数的共同样式************************/
.container-display .secondary-panel table {
  padding: 0;
  border-collapse: collapse;
}

/* 1-2-1 */
.params_form {
  height: calc(100% - 650px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 1-2-1-1 */
.params_tr {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 20px;
  min-width: 650px;

}

.params_tr .params_tr_div {
  padding-top: 15px;
  height: 35px;
  width: 25%;
  position: relative;
}

.container-display .secondary-panel h2 {
  font-size: 13px;
  padding: 0;
  border: 0;
  background-color: #e1e5ea;
}

/* label的样式~~~~~~~~~~~ */
.params_tr .params_tr_div label {
  /* line-height: 30px; */
  height: 30px;
  position: absolute;
  right: 50%;
  padding-top: 6px;
  font-size: 14px;
}


/* label的样式~~~~~~~~~~~ */
.params_tr .params_tr_div input {
  position: absolute;
  left: 55%;
}

.params_force .force_label {
  width: 100px;
  text-align: center;
  font-size: 14px;
}



input[type="number"],
input[type="text"] {
  width: 75px;
  height: 29px;
  padding: 0 5px;
  border: none;
  border-radius: 5px;
  background-color: #ffffff;
  /* background-color: #dcc1c1; */
  /* background-color: #bdd9c9c1; */
  font-size: 16px;
  text-align: center;
}

/* .params_basic的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */
.secondary-panel .params_basic {
  padding: 0 !important;
}

.secondary-panel .params_basic .basic {
  margin-left: 10px !important;
  margin-right: 30px;
}

.secondary-panel .params_basic form {
  margin-bottom: 10px;
}

.secondary-panel .params_basic fieldset {
  border: 1px solid var(--fieldset-border-color);
}

.secondary-panel .params_basic .params_tr {
  padding: 0 10px 10px 10px !important;
}

.secondary-panel .params_basic .params_tr .params_tr_div {
  padding: 0 !important;
}

.secondary-panel .params_basic legend {
  margin-bottom: 0;
}

#project_name_d {
  width: 400px;
  font-size: 14px;
  margin: 3px 0 12px 0;
}

/* 每行的第一个label的样式 */
.secondary-panel .params_basic .body,
.water_depth_high {
  width: 100px !important;
}

/* params_calculation的样式 */

.secondary-panel .params_basic .params_calculation .calculation {
  width: 19.6% !important;
  padding-top: 0px;
}

.secondary-panel .params_basic .params_calculation label {
  width: 65px !important;
}

.secondary-panel .params_basic .params_calculation h2 {
  width: 65px !important;
}

.secondary-panel .params_basic .params_calculation input {
  width: 65px !important;
}

/* 保护层厚度、沉降限值表格的样式 */
.secondary-panel .params_basic .params_table {
  position: absolute;
  top: 40px;
  left: 10px;
  z-index: 9999;
}

.secondary-panel .params_basic .deformation_table {
  top: -123px;
  left: 10px;

}

.secondary-panel .params_basic .params_table img {
  width: 200px;
  height: auto;
  border-radius: 5px;
  box-shadow: 3px 3px 3px #b3b5b6;
}

.secondary-panel .params_basic .deformation_table img {
  width: 250px;
}

/* 动态刚度特有样式 */
.secondary-panel #rotational_stiffness,
#horizontal_stiffness {
  position: relative;
}

.secondary-panel #rotational_stiffness label,
#horizontal_stiffness label {
  position: absolute;
  top: -3px;
}

.secondary-panel #rotational_stiffness input,
#horizontal_stiffness input {
  position: absolute;
  right: 0px;
}

/* .params_geometry的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */

.container-display .secondary-panel .params_geometry label {
  display: inline-block;
  width: 114px;
  text-align: right;
}

.parting_line {
  border-bottom: 1px solid #c0bfbf;
  width: 97.7%;
}

.dynamic_modulus {
  text-align: center !important;
}

/* .params_force的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */
.container-display .secondary-panel .params_force .tab {
  margin-top: 12px;
  padding-left: 10px;
  padding-bottom: 2px;
}

.container-display .secondary-panel .params_force .tip {
  padding: 5px, 0px 0px 10px;
  margin: 0px;
  font-size: 12px;
}

.container-display .secondary-panel .params_force .parting_line {
  margin-left: 10px;
  margin-bottom: 5px;
}

.container-display .secondary-panel .params_force table {
  width: 90%;
  table-layout: fixed;
  margin-left: 5%;
}

.container-display .secondary-panel .params_force th {
  font-size: 14px;
  padding: 1px 0 0 0;
}

.container-display .secondary-panel .params_force label {
  float: none;
  font-size: 14px;
}

.container-display .secondary-panel .params_force td {
  padding: 3px 8px;
}

.container-display .secondary-panel .params_force input {
  width: 90px;
}



.input_tip {
  color: #ed1e1e;
  position: absolute;
  font-size: 10px;
  width: 200px;
  z-index: 9999;
  top: 83%;
  left: -10%;

}

/* .params_soil的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */

.container-display .secondary-panel .params_soil {
  overflow: hidden;
}

.container-display .secondary-panel .params_soil .soil_container {
  height: 100%;
  overflow-y: auto;
  padding-left: 2px;
}



.container-display .secondary-panel .params_soil .soil_tr:hover {
  background-color: #d4d4d4;
}

.container-display .secondary-panel .params_soil th {
  font-size: 13px;
}

.container-display .secondary-panel .params_soil td {
  padding: 5px 6px;
}

.params_soil .soil_input {
  width: 60px !important;
}

.params_soil input[type="text"] {
  width: 140px;
  height: 29px;
  border: none;
  border-radius: 5px;
  background-color: #ffffff;
  font-size: 14px;
  text-align: center;
}


.add_soil_btn,
.delete_soil_btn {
  height: 20px;
  width: 40px;
  text-align: center;
  padding-bottom: 3px;
  vertical-align: middle;
  border-radius: 5px;
  border: none;
  background-color: var(--button-color);
  color: #fff;
  font-size: 16px;
  margin: 0px 5px;
}

.tip_for_mobile {
  display: inline-block;
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
@media (orientation: portrait) and (max-width: 768px) {
  .tip .tip_for_pc {
    display: none;
  }
}

/* .modulus_container_wraper {
  width: 100%;
  text-align: center;
  margin-top: 10px;
} */

.modulus_container {
  margin-left: 10px;
  display: inline-block;
  position: relative;
  padding: 5px;
  background-color: var(--button-color);
  border-radius: 5px;
  color: #fff;
}

.modulus_table {
  position: absolute;
  top: 30px;
  left: -250px;
}

.modulus_table img {
  width: 600px;
  height: auto;
  border-radius: 5px;
}

/* .params_bolt的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */

.params_bolt .tip {
  padding-left: 30px;
}

.params_bolt #bolt_fu,
#bolt_fy {
  padding: 6px 0 0 0;
}

/* 4. secondary_panel下的第二级div:  地震作用输入  */
.third_panel {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
  background-color: rgb(0, 0, 0, 0.6);
  z-index: 9999;
  min-height: 925px;
}

#third_panel_seism {
  display: none;
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */
@media (orientation: portrait) and (max-width: 768px) {

  .third_panel .wraper_for_mobile {
    width: 100% !important;
    min-width: 100% !important;
    overflow: scroll;
  }
}

/* 手机端样式～～～～～～～～～～～～～～～～～～～～ */



.third_panel .tab {
  display: flex;
  padding: 0;
  margin-bottom: 10px;
  justify-content: center;
}

.third_panel th {

  padding: 0 0 5px 0;

}

.third_input {
  width: 90%;
  height: 80%;
  position: absolute;
  top: 10%;
  left: 5%;
  background-color: var(--params-container-color);
  border-radius: 10px;
  box-shadow: 10px 10px 15px rgb(0, 0, 0, 0.6);
}

/* .design_bar的样式~~~~~~~~~~~~~~~~~~~~~~~~~ */
.secondary-panel .select {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 30px;
  position: absolute;
  right: 14%;
  border-radius: 5px;
  background-color: #ffffff;
  border: none;
  text-align: center;
}

.secondary-panel .select .select_list {
  background-color: #ffffff;
  border: none;
  margin-left: 4px;
}

.secondary-panel #bottom_radial_diameter,
#top_radial_diameter {
  width: 128px;
}

input[type="text"]:disabled {
  background-color: #f0f2f5f4;
}

/* 4.1. 地震作用输入 之 放大系数 */
.container-display .secondary-panel .params_amplification {
  padding-left: 10px;
}

.container-display .secondary-panel .params_amplification tr {
  padding: 0;
}

.container-display .secondary-panel .params_amplification .params_tr_div {
  width: 250px;
  padding: 0;
}

.container-display .secondary-panel .params_amplification label {
  display: inline-block;
  width: 130px;
  text-align: right;
}

/* 4.2. 地震作用输入 之 方式一 */
.third_panel .params_force {
  height: 105px;
  border: 0;
  box-shadow: none;
  margin: 0;
  padding: 0;
}

.third_panel .params_force th {
  padding: 0 !important;
}

.third_panel .params_force .temp_force {
  padding: 5px 8px 5px 24px !important;
}

/* 4.3. 地震作用输入 之 方式二*/
.third_panel .params_seism {
  height: 85px;
  border: 0;
  box-shadow: none;
  margin: 0;
}

.third_panel .params_seism select {
  width: 90px;
  height: 28px;
  position: absolute;
  left: 55%;
  border-radius: 5px;
  border: none;
  background-color: #ffffff;
}

.container-display .secondary-panel .params_seism .params_tr {
  padding: 0;
}

.container-display .secondary-panel .params_seism .params_tr_div {
  width: 240px;
  padding: 0;
  margin-bottom: 4px;
}

.container-display .secondary-panel .params_seism label {
  display: inline-block;
  width: 120px;
  text-align: right;
}

.third_panel .params_form .tab {
  margin-bottom: 6px !important;
}

/* 4.3. 地震作用结果 */
.third_panel .seism_result {
  height: 105px;
}

.third_panel .comfirm_tab {
  padding: 3px 0 0 0 !important;
}

/* 5. secondary_panel下的第二级div:  疲劳荷载输入  */
#third_panel_fatigue {
  display: none;
}

#third_panel_fatigue .third_input {
  width: 90%;
  height: 46%;
  position: absolute;
  top: 27%;
  left: 5%;
  min-height: 460px;
}

#third_panel_fatigue table {
  margin: 0 0 0 25px;
  width: 95%;

}

#third_panel_fatigue td {
  padding: 8px 0;
}

/* 5.1输入参数 */
#third_panel_fatigue .params_fatigue {
  height: 100px;
}

#third_panel_fatigue .params_fatigue .temp_force {
  padding: 5px 8px 5px 18px !important;
}

/* 5.2输入参数 */
#third_panel_fatigue .fatigue_result {
  height: 100px;
}

#third_panel_fatigue .fatigue_result .temp_force {
  padding: 5px 8px 5px 35px !important;
}

/* result 的样式 */
.result_container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: var(--params-container-color);
  margin: 0px 10px 10px 10px;
  padding: 10px 0;
  border-radius: 8px;
  border: 1px solid #000;
  box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.5);
}

.result_container table {
  width: 101%;
}

.result_container td {
  height: 18px;
  padding-top: 7px;
  border: 1px solid var(--fieldset-border-color);
  font-size: 13.5px;
}

.volum {
  display: inline-block;
  width: 24%;
  border-radius: 5px;
  border: 2px solid var(--fieldset-border-color);
  border-right: 3px solid var(--fieldset-border-color);
  overflow: hidden;
}

.reaction {
  display: inline-block;
  width: 65%;
  border-radius: 5px;
  border: 2px solid var(--fieldset-border-color);
  border-right: 3px solid var(--fieldset-border-color);
  overflow: hidden;
}


/* 计算书的样式 */
#docx {
  overflow: scroll;
  height: 100%;
}

#docx .file_tab {
  margin: 0px;
  position: fixed;
  width: 200px;
  top: 60px;
  left: 50%;
  /* transform: translateX(-25%); */
  z-index: 9999;
}

@media (orientation: portrait) and (max-width: 768px) {
  .docx_wraper {
    width: 115% !important;
    overflow: scroll;
  }

  #docx .file_tab {
    left: 35px;
  }
}

#docx button {
  margin: 5px 10px !important;

}

#docx .docx_wrapper {
  padding-top: 0 !important;
}
</style>
